export const START_RATING = 1000;

const K_FACTOR = 32;

export function expectedScore(rating: number, opponentRating: number): number {
  return 1 / (1 + 10 ** ((opponentRating - rating) / 400));
}

export function eloDeltas(
  ratingA: number,
  ratingB: number,
  scoreA: 0 | 0.5 | 1,
): { a: number; b: number } {
  const expectedA = expectedScore(ratingA, ratingB);
  const deltaA = Math.round(K_FACTOR * (scoreA - expectedA));
  return { a: deltaA, b: -deltaA };
}

export function clampRating(rating: number): number {
  return Math.max(100, Math.round(rating));
}

export function rankTitle(rating: number): string {
  if (rating >= 1600) return '监督员';
  if (rating >= 1400) return '资深受试者';
  if (rating >= 1200) return '稳定样本';
  if (rating >= 1000) return '在册受试者';
  return '待校准样本';
}
